export enum NotificationResourceType {
    MapExport = "MapExport",
    LayersImport = "LayersImport",
    LayersCopy = "LayersCopy",
    MapsCopy = "MapsCopy"
}